'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var InputAdornment = _interopDefault(require('@material-ui/core/InputAdornment'));
var Search = _interopDefault(require('@material-ui/icons/Search'));
var styledComponents = require('./styled-components.js');

var OutlinedInputWithIcon = function (props) {
    var title = props.title, titleHover = props.titleHover, onChange = props.onChange, _a = props.Icon, Icon = _a === void 0 ? Search : _a, id = props.id, height = props.height, style = props.style, padding = props.padding, adornmentColor = props.adornmentColor, borderColor = props.borderColor, defaultValue = props.defaultValue, value = props.value, error = props.error, disabled = props.disabled;
    var handleChange = function (e) {
        e.persist();
        onChange(e);
    };
    return (React__default.createElement(styledComponents.StyledFormControl, { style: tslib.__assign({ margin: 0 }, style) },
        React__default.createElement(styledComponents.StyledInput, { id: id, placeholder: title, onChange: handleChange, startAdornment: React__default.createElement(InputAdornment, { position: 'start', title: titleHover },
                React__default.createElement(Icon, null)), height: height, padding: padding, adornmentcolor: adornmentColor, fullWidth: true, bordercolor: borderColor, defaultValue: defaultValue, value: value, error: error, disabled: disabled, style: { height: '35px' } })));
};

module.exports = OutlinedInputWithIcon;
